import React from 'react'
import { webSocket } from './socket'

export var updateResponse;

export const sendRequestFiles = function (data) {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'loadFileData': data }));
        updateResponse = resolve;
    });
    return promise;
}

export const requestFiles = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendRequestFiles(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}


export const sendRequestPlaces = function (data) {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'PlacesForUpdateManagerRequest': data }));
        updateResponse = resolve;
    });
    return promise;
}

export const requestPlaces = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendRequestPlaces(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}


export const sendRequestDevices = function (data) {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'DevicesForUpdateManagerRequest': data }));
        updateResponse = resolve;
    });
    return promise;
}


export const requestDevices = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendRequestDevices(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}

export const sendCreateSchedule = function (data) {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'CreateUpdateScheduleRequest': data }));
        updateResponse = resolve;
    });
    return promise;
}


export const createSchedule = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendCreateSchedule(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}
export const sendDeleteSchedule = function (data) {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'ChangeUpdateScheduleRequest': data }));
        updateResponse = resolve;
    });
    return promise;
}


export const deleteSchedule = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendDeleteSchedule(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}